<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7">
          Dárek
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-7">
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID</div>
                  <div class="request-value mt-2">
                    {{ gift.id }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název</div>
                  <div class="request-value mt-2">
                    {{ gift.name ? gift.name : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Počet promo kódů v rámci objednávky</div>
                  <div class="request-value mt-2">
                    {{ gift.promoCodeApplyCount ? gift.promoCodeApplyCount : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Id kampaně - mailkit</div>
                  <div class="request-value mt-2">
                    {{ gift.campaignId ? gift.campaignId : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Id seznamu příjemců - mailkit</div>
                  <div class="request-value mt-2">
                    {{ gift.campaignListId ? gift.campaignListId : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Url návod na aktivaci</div>
                  <div class="request-value mt-2">
                    <template v-if="gift.guideLink">
                      <a :href="gift.guideLink">{{ gift.guideLink }}</a>
                    </template>
                    <template v-else> - </template>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!--          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Platnost od</div>
                  <div class="request-value mt-2">
                    {{ gift.validUntil ? $dayjs(gift.validUntil).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Platnost to</div>
                  <div class="request-value mt-2">
                    {{ gift.validTo ? $dayjs(gift.validTo).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <template>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :to="{ name: 'gifts.edit', params: { giftId: gift.id } }"
            >
              Editovat
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
    <PromoCodes />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PromoCodes from './promo/PromoCodes'

export default {
  name: 'GiftDetail',
  components: { PromoCodes },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      gift: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadGift()
  },
  methods: {
    ...mapActions({
      getGift: 'gift/getGift',
    }),
    loadGift() {
      this.loading = true
      this.getGift(this.$route.params.giftId)
        .then((response) => {
          this.gift = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.push({
        name: 'gifts',
      })
    },
  },
}
</script>
